import React from 'react';
import '../css/ourPartners.css';

const OurPartners = ({ data }) => {
  return (
    <section
      className="py-md-5 lazy-bg skeleton loaded our-clients"
      data-bg="url(/images/partner.png)"
      style={{
        backgroundImage: "url('/images/partner.png')",
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container">
        <h2 className="text-center default-box-title">ĐỐI TÁC ĐỒNG HÀNH</h2>
        <p className="description">
          Gắn kết – Uy tín – Phát triển vì cộng đồng Cựu sinh viên Kinh tế K21 –
          Đại học Cần Thơ
        </p>
        <div className="row items">
          {data.map((item, index) => (
            <div key={index} className="col-lg-2 col-md-4 col-6 item  ">
              <div className="text-center client-logo lazy-container position-relative">
                <div
                  className="skeleton aspect-ratio-client-logo"
                  style={{ display: 'none' }}
                ></div>
                <img
                  data-src={item.imageUrl}
                  alt={item.title}
                  loading="lazy"
                  src={item.imageUrl}
                />
              </div>
              <p style={{ textAlign: 'center', fontSize: '13px' }}>
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurPartners;
